import { getAllFeild, createAdvertismentData } from "../../../api/advertisment/create/fields.js";
import { Button, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Dropdown, TextInput } from "../../../../../shared/ui/common/index.js";




const FeildAdsValue = ({ id }) => {
  const [showingCats, setShowingCats] = useState([]);
  const [catSearchWord, setCatSearchWord] = useState("");
  const [category, setCategory] = useState("");
  const [prev, setPrev] = useState([]);
  const [value, setValue] = useState("");
  const { token } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllFeild(token)
      .then((res) => {
        const { data } = res;
        setShowingCats(data?.data);
      })
      .catch((err) => {});
  }, []);
  const sumbitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    var temp = [...prev];
    createAdvertismentData(id, category, value, token)
      .then((res) => {
        temp.push({ advertisementId: id, fieldId: category?.id, value });
        setPrev(temp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <div>
      <form onSubmit={sumbitHandler} className="grid md:grid-cols-3 gap-10 ">
        <Dropdown
          search={(e) => {
            setCatSearchWord(e.target.value);
          }}
          searchValue={catSearchWord}
          title="انتخاب  فیلد"
          data={showingCats}
          value={category}
          change={setCategory}
          /*   err={error === "category"} */
        />
        <TextInput label="مقدار " change={setValue} currentValue={value} />
        <div>
          {" "}
          <Button type="submit" disabled={loading} variant="contained">
            {loading ? <CircularProgress /> : <> ثبت</>}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FeildAdsValue;
